import { j as e, c as C } from "../../utils-BdNIfrGQ.js";
import S, { hexToHSL as _ } from "../../theme/provider/ThemeProvider.mjs";
import { createElement as H, useMemo as I } from "react";
import { T as P } from "../../ThumbnailImage-CQfW_Fzc.js";
import { H as R } from "../../H2-CGvOaVnq.js";
import { u as A } from "../../index-C0pJYwuM.js";
import "../../ScrollToGrid-DSDgndge.js";
import { S as y } from "../../Split-CEoNwvSo.js";
import { D as i } from "../../Div-spVpsZsH.js";
import { D as v } from "../../Div.skeleton-DLnqOZrU.js";
import { F as t } from "../../Flex-BA9xHq_p.js";
import "../../Grid-DJGISvmf.js";
import { N as E } from "../../NavLink-D9Qfouy1.js";
import { H as M } from "../../HamburgerMenu-DtU03V0t.js";
import { P as O, a as V } from "../../PageContext.skeleton-CUBmK2_q.js";
import { a as F } from "../../Button-CzIiGCVn.js";
import { L as D } from "../../List-L_RxfO5h.js";
import { E as U } from "../../ExternalLink-CwLUkrFF.js";
import { P as Y } from "../../Paragraph-Cpgi01iq.js";
import { T as k } from "../../Text-BhLXzYEf.js";
import { c as K } from "../../index-Di82Y7n3.js";
import { H as W } from "../../Header-rsvbExbw.js";
import { B as X } from "../../BackgroundImage-BY06z4x1.js";
import q from "./components/PageBanner.mjs";
import "../../toast-DrFMmSLk.js";
import "react-dom";
import { u as G, R as $ } from "../../ResponsiveProvider-BC7BKjLV.js";
import { B as w } from "../../Button.skeleton-D0Onk1OP.js";
import { T as J } from "../../toaster-DencLePE.js";
import "../avatar/Avatar.mjs";
const Z = K("", {
  variants: {
    branding: {
      primary: "bg-primary text-primary-foreground",
      secondary: "bg-secondary text-secondary-foreground",
      transparent: "bg-transparent text-branded-foreground",
      inherit: "bg-inherit text-inherit"
    }
  },
  defaultVariants: {
    branding: "inherit"
  }
}), a = "https://raceroster.com", Q = (r) => {
  switch (r.split("-")[0]?.toLowerCase()) {
    case "en":
      return `${a}/legal/privacy-policy`;
    case "fr":
      return `${a}/legal/privacy-policy-fr-ca`;
    case "ja":
      return `${a}/legal/privacy-policy-ja`;
    case "es":
      return `${a}/legal/privacy-policy-es`;
    case "zh":
      return `${a}/legal/privacy-policy-hongkong`;
    case "ms":
      return `${a}/legal/privacy-policy-my`;
    default:
      return `${a}/legal/privacy-policy`;
  }
}, ee = (r) => {
  switch (r.split("-")[0]?.toLowerCase()) {
    case "en":
      return `${a}/legal/tos-for-event-registrants`;
    case "fr":
      return `${a}/legal/tos-event-registrants-fr`;
    case "ja":
      return `${a}/legal/tos-event-registrants-ja`;
    case "es":
      return `${a}/legal/tos-event-registrants-es`;
    case "zh":
      return `${a}/legal/tos-event-registrants-hongkong`;
    // TODO: When the Melayu language has a ToS page, uncomment this case
    // case 'ms':
    //   return `${RACE_ROSTER_DOMAIN}/legal/tos-event-registrants-my`;
    default:
      return `${a}/legal/tos-for-event-registrants`;
  }
}, re = ({
  branding: r = "transparent",
  isQuebecEvent: o,
  locale: s = "en-US",
  byRaceRoster: n = "Powered by Race Roster",
  privacyLinkLabel: l,
  termsLinkLabel: h,
  copyRightLabel: g,
  additionalInfo: c,
  contactUs: m
}) => {
  const f = Q(o ? "fr-CA" : s), d = ee(o ? "fr-CA" : s), p = [
    {
      id: "privacy",
      href: f,
      children: l
    },
    {
      id: "terms",
      href: d,
      children: h
    }
  ];
  return /* @__PURE__ */ e.jsx(
    "footer",
    {
      className: C(Z({ branding: r }), "z-1 w-full pt-[48px] pb-6 px-6 md:px-7"),
      children: /* @__PURE__ */ e.jsxs(t, { gap: "7", className: "flex-col md:flex-row-reverse justify-between", children: [
        /* @__PURE__ */ e.jsxs(t, { className: "flex-col items-start md:items-end", children: [
          /* @__PURE__ */ e.jsxs(D, { direction: "horizontal", gap: "7", children: [
            p?.map((x) => /* @__PURE__ */ e.jsx("li", { children: /* @__PURE__ */ e.jsx(U, { href: x.href, target: "_blank", children: x.children }) }, x.id)),
            m && /* @__PURE__ */ e.jsx("li", { children: /* @__PURE__ */ e.jsx(
              F,
              {
                type: "button",
                variant: "link",
                size: "full",
                rounded: "none",
                onClick: m.onClick,
                children: m.label
              }
            ) }, "contact-us")
          ] }),
          c && /* @__PURE__ */ e.jsx(i, { className: "text-muted-foreground text-sm", children: /* @__PURE__ */ e.jsx(k, { children: c }) })
        ] }),
        /* @__PURE__ */ e.jsxs(i, { className: "text-sm", children: [
          /* @__PURE__ */ e.jsx(Y, { fontWeight: "semibold", children: n }),
          /* @__PURE__ */ e.jsx(k, { children: g })
        ] })
      ] })
    }
  );
}, te = ({ hamburgerMenu: r }) => /* @__PURE__ */ e.jsx(i, { className: "top-0 left-0 right-0 z-2", children: /* @__PURE__ */ e.jsx(W, { background: "transparent", children: /* @__PURE__ */ e.jsx(t, { className: "items-center justify-end w-full", children: /* @__PURE__ */ e.jsx(t, { className: "ml-auto justify-end min-w-[85px] lg:min-w-fit", children: /* @__PURE__ */ e.jsx(M, { ...r }) }) }) }) }), se = ({ srcUrl: r }) => /* @__PURE__ */ e.jsx(X, { src: r, alt: "", className: "z-0" }), ae = (r) => {
  const { children: o, aiSlot: s } = r;
  return /* @__PURE__ */ e.jsxs(
    i,
    {
      className: "sticky bottom-0 flex flex-col bg-white text-inherit w-full py-5 px-6 z-10 shadow-[0px_-2px_8px_0px_hsla(0,0%,10%,0.071)]",
      children: [
        s && /* @__PURE__ */ e.jsx(i, { className: "absolute right-6 bottom-full mb-5", children: s }),
        o
      ]
    }
  );
}, oe = ({
  pageHeader: r,
  pageFooter: o,
  pageNavLinks: s,
  bannerProps: n,
  pageCtx: l,
  children: h,
  slots: g,
  brandedBackground: c,
  dynamicWidth: m,
  containerFooterSlot: f
}) => {
  const { callToAction: d, stickyHeaderActions: p, aiSlot: x } = g, { isMobile: u, isPortrait: j, isXL: z } = G(), N = u || j, { ref: T, inView: L } = A({
    threshold: 0,
    rootMargin: "0px",
    initialInView: !0
  }), B = m && z ? "min-w-[1024px] w-fit max-w-[95%]" : "w-full max-w-[1024px]";
  return /* @__PURE__ */ e.jsxs(t, { className: "relative flex-col min-h-screen bg-branded-background", children: [
    /* @__PURE__ */ e.jsx(te, { ...r }),
    n?.bannerImage && (n.bannerImage.desktop || n.bannerImage.mobile) && /* @__PURE__ */ e.jsx(q, { ...n }),
    /* @__PURE__ */ e.jsx(
      "main",
      {
        className: `z-1 flex flex-col flex-1 ${B} mx-auto my-2 gap-7`,
        children: /* @__PURE__ */ e.jsxs(
          i,
          {
            className: `relative rounded-[32px] shadow-lg bg-white border border-b-gray-400 ${u ? "pt-7" : "pt-9"} pb-11`,
            children: [
              !u && p && /* @__PURE__ */ e.jsx(i, { className: "sticky top-0 z-1 h-0 pointer-events-none", children: /* @__PURE__ */ e.jsx(
                i,
                {
                  "data-testid": "sticky-cta-container",
                  "data-sticky-visible": L ? "false" : "true",
                  className: "absolute inset-x-0 top-0 z-1 bg-white px-9 py-4 border-b border-b-gray-200 opacity-0 invisible pointer-events-none data-[sticky-visible=true]:opacity-100 data-[sticky-visible=true]:visible data-[sticky-visible=true]:pointer-events-auto",
                  children: /* @__PURE__ */ e.jsx(
                    y,
                    {
                      leftSlot: /* @__PURE__ */ e.jsxs(t, { className: "flex-grow flex-row items-center", gap: "4", children: [
                        l.logo && /* @__PURE__ */ e.jsx(t, { className: "bg-transparent self-start flex-shrink-0 h-fit", children: /* @__PURE__ */ e.jsx(P, { src: l.logo.src, alt: l.logo.alt, size: "xs" }) }),
                        /* @__PURE__ */ e.jsx(R, { align: "left", size: "lg", children: l.name })
                      ] }),
                      rightSlot: p && /* @__PURE__ */ e.jsx(i, { children: p }),
                      orientation: "horizontal"
                    }
                  )
                }
              ) }),
              /* @__PURE__ */ e.jsxs(
                t,
                {
                  gap: "0 7",
                  className: `flex-col ${m ? "max-w-[1024px] mx-auto" : ""} px-7 sm:px-9 ${s?.length ? "border-b border-b-gray-200" : ""}`,
                  children: [
                    /* @__PURE__ */ e.jsx(
                      y,
                      {
                        leftSlot: /* @__PURE__ */ e.jsx(O, { ...l }),
                        rightSlot: N ? void 0 : /* @__PURE__ */ e.jsx(i, { children: d }),
                        orientation: "responsive"
                      }
                    ),
                    s?.length && /* @__PURE__ */ e.jsx("nav", { children: /* @__PURE__ */ e.jsx(t, { gap: "4", ref: T, className: "relative z-2 overflow-x-auto bg-white", children: s.map((b) => /* @__PURE__ */ H(E, { ...b, key: b.id, variant: "pageLink" }, b.children)) }) })
                  ]
                }
              ),
              /* @__PURE__ */ e.jsxs(
                t,
                {
                  "data-testid": "page-content-container",
                  gap: "7",
                  className: "flex-col pt-6 px-7 sm:pt-9 sm:px-9 [&>*]:border-b [&>*]:border-border [&>*:last-child]:border-b-0 [&>*]:pb-7 [&>*:last-child]:pb-0",
                  children: [
                    h,
                    f
                  ]
                }
              )
            ]
          }
        )
      }
    ),
    /* @__PURE__ */ e.jsx(re, { ...o }),
    c && /* @__PURE__ */ e.jsx(se, { srcUrl: c.srcUrl }),
    d && N && /* @__PURE__ */ e.jsx(ae, { aiSlot: x, children: d })
  ] });
}, Ee = ({
  pageHeader: r,
  pageFooter: o,
  pageNavLinks: s,
  bannerProps: n,
  pageCtx: l,
  children: h,
  slots: g,
  brandingColors: c,
  brandedBackground: m,
  dynamicWidth: f,
  containerFooterSlot: d
}) => {
  const p = I(() => {
    if (c)
      return Object.entries(c).reduce((x, [u, j]) => (x[u] = _(j), x), {});
  }, [c]);
  return /* @__PURE__ */ e.jsx(S, { themeConfig: { brandingColors: p }, children: /* @__PURE__ */ e.jsxs($, { children: [
    /* @__PURE__ */ e.jsx(J, {}),
    /* @__PURE__ */ e.jsx(
      oe,
      {
        pageHeader: r,
        pageNavLinks: s,
        pageFooter: o,
        bannerProps: n,
        pageCtx: l,
        slots: g,
        dynamicWidth: f,
        brandedBackground: m,
        containerFooterSlot: d,
        children: h
      }
    )
  ] }) });
}, ie = () => /* @__PURE__ */ e.jsx(
  t,
  {
    className: "h-[50px] flex-row justify-end items-center px-5",
    "data-testid": "header-skeleton",
    children: /* @__PURE__ */ e.jsx(t, { className: "w-[85px] justify-end", children: /* @__PURE__ */ e.jsx(w, { grayVariant: 300, variant: "outline" }) })
  }
), ne = () => /* @__PURE__ */ e.jsx(v, { className: "h-[100px] md:h-[80px]", "data-testid": "footer-skeleton" }), Me = ({ bannerProps: r, name: o }) => {
  const s = r ? "mt-[-12px] lg:mt-[-48px]" : "mt-[80px]";
  return /* @__PURE__ */ e.jsx(S, { children: /* @__PURE__ */ e.jsx($, { children: /* @__PURE__ */ e.jsxs(t, { className: "flex-col min-h-screen bg-background", "data-testid": "layout-skeleton", children: [
    /* @__PURE__ */ e.jsx(ie, {}),
    r && /* @__PURE__ */ e.jsx(
      v,
      {
        className: "h-[200px] md:h-[500px] w-full",
        "data-testid": "banner-skeleton"
      }
    ),
    /* @__PURE__ */ e.jsx(
      t,
      {
        gap: "7",
        className: `flex-col flex-1 w-full max-w-[1024px] mx-auto ${s} overflow-scroll`,
        children: /* @__PURE__ */ e.jsxs(i, { className: "relative rounded-lg bg-white border border-b-gray-400", children: [
          /* @__PURE__ */ e.jsxs(t, { gap: "7", className: "flex-col px-7 pt-[32px] border-b border-b-gray-200", children: [
            /* @__PURE__ */ e.jsx(
              y,
              {
                leftSlot: /* @__PURE__ */ e.jsx(V, { name: o }),
                rightSlot: /* @__PURE__ */ e.jsx(w, { grayVariant: 400, size: "lg" })
              }
            ),
            /* @__PURE__ */ e.jsx("nav", { children: /* @__PURE__ */ e.jsx(t, { gap: "4", className: "overflow-x-auto", children: [{ id: 1 }, { id: 2 }, { id: 3 }].map(({ id: n }) => /* @__PURE__ */ e.jsx(w, { variant: "link" }, n)) }) })
          ] }),
          /* @__PURE__ */ e.jsx(i, { className: "px-7 py-[32px]", children: /* @__PURE__ */ e.jsx(v, { className: "h-[500px] w-full", grayVariant: 200 }) })
        ] })
      }
    ),
    /* @__PURE__ */ e.jsx(ne, {})
  ] }) }) });
}, Oe = {
  "--ai-chat-floating-offset": "var(--sticky-cta-height)"
};
export {
  Ee as AppLayout,
  oe as AppLayoutContent,
  Me as AppLayoutSkeleton,
  M as HamburgerMenu,
  q as PageBanner,
  re as PageFooter,
  ne as PageFooterSkeleton,
  te as PageHeader,
  ie as PageHeaderSkeleton,
  $ as ResponsiveProvider,
  Oe as STICKY_MOBILE_SECTION_OFFSET_STYLE,
  G as useResponsive
};
